var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg018Favorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-arrow-direction-button-pointer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 62a30 30 0 1 1 30-30 30.034 30.034 0 0 1 -30 30zm0-58a28 28 0 1 0 28 28 28.032 28.032 0 0 0 -28-28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 8.079a1 1 0 0 1 -.078-2c.688-.051 1.388-.079 2.078-.079a1 1 0 0 1 0 2c-.638 0-1.284.025-1.921.076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 33a1 1 0 0 1 -1-1 25.953 25.953 0 0 1 19.76-25.243 1 1 0 1 1 .48 1.943 23.959 23.959 0 0 0 -18.24 23.3 1 1 0 0 1 -1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.489 47.1a2 2 0 0 1 -1.175-.389 1.972 1.972 0 0 1 -.727-2.236l3.184-9.8-8.335-6.056a2 2 0 0 1 1.175-3.619h10.3l3.189-9.8a2 2 0 0 1 3.8 0l3.186 9.8h10.3a2 2 0 0 1 1.175 3.618l-8.335 6.056 3.184 9.8a2 2 0 0 1 -3.078 2.236l-8.332-6.058-8.335 6.056a1.989 1.989 0 0 1 -1.176.392zm9.511-8.449a2 2 0 0 1 1.175.383l8.336 6.056-3.184-9.8a2 2 0 0 1 .727-2.236l8.335-6.054h-10.3a2 2 0 0 1 -1.9-1.382l-3.189-9.798v-.012l-3.179 9.81a2 2 0 0 1 -1.907 1.382h-10.3l8.335 6.056a2 2 0 0 1 .727 2.236l-3.184 9.8 8.335-6.056a2 2 0 0 1 1.173-.385z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg018Favorite);
export default __webpack_public_path__ + "static/media/018-favorite.1c271353a50740c8679f102b318c46ee.svg";
export { ForwardRef as ReactComponent };